export const Data = {
  kycReasons: [
    {
      icon: "money-laundering",
      title: "guide.KYC_REASONS_TITLE_1",
      text: "guide.KYC_REASONS_TEXT_1",
    },
    {
      icon: "safety",
      title: "guide.KYC_REASONS_TITLE_2",
      text: "guide.KYC_REASONS_TEXT_2",
    },
    {
      icon: "rules",
      title: "guide.KYC_REASONS_TITLE_3",
      text: "guide.KYC_REASONS_TEXT_3",
    },
  ],
  kycBenefits: [
    {
      icon: "notebook",
      title: "guide.KYC_BENEFITS_1",
      text: "guide.KYC_BENEFITS_TEXT_1",
    },
    {
      icon: "bag",
      title: "guide.KYC_BENEFITS_2",
      text: "guide.KYC_BENEFITS_TEXT_2",
    },
  ],
  kycSteps: [
    {
      id: "۱",
      title: "guide.KYC_STEPS_1",
      text: "guide.KYC_STEPS_TEXT_1",
    },
    {
      id: "۲",
      title: "guide.KYC_STEPS_2",
      text: "guide.KYC_STEPS_TEXT_2",
    },
    {
      id: "۳",
      title: "guide.KYC_STEPS_3",
      text: "guide.KYC_STEPS_TEXT_3",
    },
  ],
  startPoint: [
    {
      img: "/images/guide/start-1.png",
      title: "guide.START_POINT_TITLE_1",
      text: "guide.START_POINT_TEXT_1",
      link: "https://bitmax.ir/blog/%D8%A8%D8%A7-%DA%A9%D8%AF%D8%A7%D9%85-%DA%A9%D9%88%DB%8C%D9%86-%D8%B4%D8%B1%D9%88%D8%B9-%DA%A9%D9%86%D9%85%D8%9F/",
    },
    {
      img: "/images/guide/start-2.png",
      title: "guide.START_POINT_TITLE_2",
      text: "guide.START_POINT_TEXT_2",
      link: "https://bitmax.ir/blog/%DA%86%DA%AF%D9%88%D9%86%D9%87-%D8%AA%D8%B5%D9%85%DB%8C%D9%85%DA%AF%DB%8C%D8%B1%DB%8C-%DA%A9%D9%86%D9%85%D8%9F/",
    },
  ],
  coins: [
    {
      name: "guide.COIN_NAME_1",
      img: "/images/guide/usdt.png",
      text: "guide.COIN_TEXT_1",
    },
    {
      name: "guide.COIN_NAME_2",
      img: "/images/guide/eth.png",
      text: "guide.COIN_TEXT_2",
    },
    {
      name: "guide.COIN_NAME_3",
      img: "/images/guide/alt.png",
      text: "guide.COIN_TEXT_3",
    },
  ],
}

export default Data
